import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/course_empty1.png';
const _withScopeId = n => (_pushScopeId("data-v-c52f2b20"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "info-block"
};
const _hoisted_2 = {
  class: "info-block-left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "image-slot"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "100%"
  },
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_4 = {
  class: "info-block-right"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载通告", -1));
const _hoisted_7 = {
  class: "info-data-area"
};
const _hoisted_8 = {
  key: 0,
  class: "info-date"
};
const _hoisted_9 = {
  key: 1,
  class: "info-date"
};
const _hoisted_10 = {
  key: 2,
  class: "info-area"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "info-price"
};
const _hoisted_13 = {
  key: 0,
  class: "price free"
};
const _hoisted_14 = {
  key: 1,
  class: "price"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, " 加入学习后，开始计时 ", -1));
const _hoisted_16 = {
  class: "study-status"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  class: "info-status"
};
import { reactive, watch } from 'vue';
import { getImgUrl } from '@/utils/common';
import dayjs from 'dayjs';
export default {
  __name: 'index',
  props: {
    courseInfo: {
      type: Object,
      default: () => {}
    },
    buttonText: {
      type: String
    },
    disabledButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['learn', 'live', 'signUp'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const state = reactive({
      nowText: props.buttonText || '加入学习',
      nowInfo: props.courseInfo || {},
      color: 'rgb(3, 159, 121)',
      style: {
        background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
        border: 0
      },
      signUpColor: 'rgb(196, 86, 86)',
      signUpStyle: {
        background: 'linear-gradient(4.35488836643947deg, rgba(229, 92, 62, 1) 1%, rgba(255, 154, 154, 1) 99%)',
        border: 0
      },
      disabledButton: false,
      disabledLiveButton: true,
      liveText: '即将开课',
      visibleButton: false,
      showPreSignUp: false,
      textTips: '',
      signUpText: '预报名',
      disabledSignUpButton: false
    });
    watch(() => props.buttonText, val => {
      state.nowText = val;
    });
    watch(() => props.disabledButton, val => {
      state.disabledButton = val;
    });
    watch(() => props.courseInfo, val => {
      togleButtonText(props.courseInfo);
      showButton();
    });
    const showButton = () => {
      if (props.courseInfo.coursePlayType === '1' && props.courseInfo.learnStatus === true) {
        state.visibleButton = true;
      } else {
        state.visibleButton = false;
      }
      if (props.courseInfo.free === '1' && !props.courseInfo.learnStatus) {
        state.showPreSignUp = true;
      } else {
        state.showPreSignUp = false;
      }
    };
    function togleButtonText(info) {
      if (info.coursePlayType === '1') {
        info.free === '1' ? payLiveCourse(info) : freeLiveCourse(info);
      } else {
        info.free === '1' ? payCourse(info) : freeCourse(info);
      }
      if (info.coursePreRegisterFlag === '1') {
        state.disabledSignUpButton = true;
        state.signUpText = '已报名';
        state.signUpStyle = {
          background: '#ddd',
          border: 0
        };
      } else {
        state.disabledSignUpButton = false;
      }
    }

    // 免费录播课
    const freeCourse = () => {
      state.style = {
        background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
        border: 0
      };
      if (props.courseInfo.learnStatus === true) {
        state.nowText = '继续学习';
        state.color = 'rgb(3, 159, 121)';
      } else {
        state.nowText = '加入学习';
        state.color = 'rgb(3, 159, 121)';
      }
    };

    // 免费直播课
    const freeLiveCourse = () => {
      if (props.courseInfo.learnStatus === true) {
        state.nowText = '已加入';
        state.disabledButton = true;
        state.color = 'rgb(3, 159, 121)';
        state.style = {
          background: '#ddd',
          border: 0
        };
        liveStatusButton(props.courseInfo);
      } else {
        state.nowText = '培训报名';
        state.color = 'rgb(3, 159, 121)';
        state.style = {
          background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
          border: 0
        };
      }
    };

    // 付费录播课
    const payCourse = () => {
      if (props.courseInfo.learnStatus === true) {
        state.nowText = '继续学习';
        state.color = 'rgb(196, 86, 86)';
        state.style = {
          background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
          border: 0
        };
      } else {
        state.nowText = '缴费';
        state.color = 'rgb(196, 86, 86)';
        state.style = {
          background: 'linear-gradient(4.35488836643947deg, rgba(229, 92, 62, 1) 1%, rgba(255, 154, 154, 1) 99%)',
          border: 0
        };
      }
    };

    // 付费直播课
    const payLiveCourse = () => {
      if (props.courseInfo.learnStatus === true) {
        state.nowText = '已报名';
        state.disabledButton = true;
        state.color = 'rgb(196, 86, 86)';
        state.style = {
          background: '#ddd',
          border: 0
        };
        liveStatusButton(props.courseInfo);
      } else {
        state.nowText = '缴费';
        state.color = 'rgb(196, 86, 86)';
        state.style = {
          background: 'linear-gradient(4.35488836643947deg, rgba(229, 92, 62, 1) 1%, rgba(255, 154, 154, 1)) 99%',
          border: 0
        };
      }
    };

    // 下载通告
    const onDownload = document => {
      location.href = getImgUrl(document);
    };
    const toLearn = () => {
      emit('learn');
    };
    const toSignUp = () => {
      emit('signUp');
    };
    // 直播按钮
    const liveStatusButton = info => {
      switch (info === null || info === void 0 ? void 0 : info.liveStatus) {
        case 'LIVING':
          state.liveText = '进入直播';
          state.disabledLiveButton = false;
          state.style = {
            background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
            border: 0
          };
          break;
        case 'END':
          state.liveText = '观看回放';
          state.disabledLiveButton = false;
          state.style = {
            background: 'linear-gradient(85.6451deg, rgb(0, 179, 138) 1%, rgb(28, 223, 176) 99%)',
            border: 0
          };
          break;
        default:
          state.liveText = '即将开课';
          state.disabledLiveButton = true;
          state.style = {
            background: '#ddd',
            border: 0
          };
          break;
      }
    };
    const toLive = () => {
      emit('live');
    };

    // const inter = () => {
    //   state.interTime = setInterval(() => {
    //     state.now = new Date() // 获取当前时间
    //   }, 1000)
    // }

    // const timeReversal = (remainingTime) => {
    //   const seconds = remainingTime / 1000 // 将剩余时间转换为秒
    //   const minutes = seconds / 60 // 将剩余时间转换为分钟
    //   const hours = minutes / 60 // 将剩余时间转换为小时
    //   const days = hours / 24 // 将剩余时间转换为天数
    //   const remainingDays = Math.floor(days) // 取整得到剩余天数
    //   const remainingHours = Math.floor(hours % 24) // 取余得到剩余小时数
    //   const remainingMinutes = Math.floor(minutes % 60) // 取余得到剩余分钟数
    //   const remainingSeconds = Math.floor(seconds % 60) // 取余得到剩余秒数
    //   return { remainingDays: remainingDays, remainingHours: remainingHours, remainingMinutes: remainingMinutes, remainingSeconds: remainingSeconds }
    // }

    // // 个位数补零
    // const addZero = (num) => {
    //   return num < 10 ? '0' + num : num
    // }

    // // 直播课：报名结束剩余时间
    // const getRegisterRemainingTime = (startTime, endTime) => {
    //   state.now = new Date().getTime() // 获取当前时间
    //   const remainingStartTime = startTime - state.now // 计算开课剩余时间
    //   const remainingEndTime = endTime - state.now // 计算结课剩余时间
    //   if (remainingStartTime <= 0) {
    //     if (remainingEndTime > 0) {
    //       state.textTips = '课程进行中'
    //     } else {
    //       state.textTips = '课程已结束，可观看回放'
    //     }
    //   } else {
    //     const { remainingDays, remainingHours } = timeReversal(remainingStartTime)
    //     state.textTips = '距离开播剩余：'
    //     return remainingDays + '天' + remainingHours + '时'
    //   }
    // }

    // // 录播课：加入学习后学习倒计时：时分秒
    // const getRemainingTime = (createTime, circle) => {
    //   state.now = new Date().getTime() // 获取当前时间
    //   const remainingTime = circle * 24 * 60 * 60 * 1000 - (state.now - createTime) // 计算剩余时间
    //   if (remainingTime <= 0) {
    //     state.textTips = '课程已结束'
    //   } else {
    //     const { remainingDays, remainingHours, remainingMinutes, remainingSeconds } = timeReversal(remainingTime)
    //     state.textTips = '距离结课剩余：'
    //     return remainingDays + '天' + addZero(remainingHours) + '时' + addZero(remainingMinutes) + '分' + addZero(remainingSeconds) + '秒'
    //   }
    // }

    // onMounted(() => {
    //   inter()
    // })

    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
        class: "course-img",
        src: props.courseInfo.cover ? _unref(getImgUrl)(props.courseInfo.cover) : ''
      }, {
        error: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["src"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "info-title",
        title: props.courseInfo.courseName
      }, _toDisplayString(props.courseInfo.courseName), 9, _hoisted_5), props.courseInfo.document ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "download",
        onClick: _cache[0] || (_cache[0] = $event => onDownload(props.courseInfo.document))
      }, [_createVNode(_component_Icon, {
        name: "el-icon-Download"
      }), _hoisted_6])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [props.courseInfo.coursePlayType === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "学习周期:" + _toDisplayString(props.courseInfo.courseCycle || 0) + " 天", 1)) : _createCommentVNode("", true), props.courseInfo.coursePlayType === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_9, "培训周期:" + _toDisplayString(props.courseInfo.courseStartTime ? _unref(dayjs)(+props.courseInfo.courseStartTime).format('YYYY-MM-DD') : 0) + " ~ " + _toDisplayString(props.courseInfo.courseEndTime ? _unref(dayjs)(+props.courseInfo.courseEndTime).format('YYYY-MM-DD') : 0), 1)) : _createCommentVNode("", true), props.courseInfo.coursePlayType === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createTextVNode(" 培训地点:" + _toDisplayString(props.courseInfo.courseModel === '1' ? '线上' : '线下') + " ", 1), props.courseInfo.address ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(props.courseInfo.address), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [props.courseInfo.free === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 免费 ")) : (_openBlock(), _createElementBlock("div", _hoisted_14, " ￥ " + _toDisplayString(props.courseInfo.price), 1)), _hoisted_15]), _createElementVNode("div", _hoisted_16, [__props.courseInfo.contentName ? (_openBlock(), _createElementBlock("span", _hoisted_17, "学习到 " + _toDisplayString(__props.courseInfo.contentName), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [state.showPreSignUp ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        color: state.signUpColor,
        style: _normalizeStyle(state.signUpStyle),
        round: "",
        large: "",
        onClick: toSignUp,
        disabled: state.disabledSignUpButton
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(state.signUpText), 1)]),
        _: 1
      }, 8, ["color", "style", "disabled"])) : _createCommentVNode("", true), !state.visibleButton ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        color: state.color,
        style: _normalizeStyle(state.style),
        round: "",
        large: "",
        onClick: toLearn,
        disabled: state.disabledButton
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(state.nowText), 1)]),
        _: 1
      }, 8, ["color", "style", "disabled"])) : _createCommentVNode("", true), state.visibleButton ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        color: state.color,
        style: _normalizeStyle(state.style),
        disabled: state.disabledLiveButton,
        round: "",
        large: "",
        onClick: toLive
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(state.liveText), 1)]),
        _: 1
      }, 8, ["color", "style", "disabled"])) : _createCommentVNode("", true)])])]);
    };
  }
};